import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateLanyardTemplate,
  serviceGetLanyardTemplate,
  serviceUpdateLanyardTemplate,
  serviceDeleteLanyardTemplate,
} from "../services/LanyardTemplate.service";
import EventEmitter from "../libs/Events.utils";
export const FETCH_INIT = "FETCH_INIT_LANYARD_TEMPLATE";
export const FETCHED = "FETCHED_LANYARD_TEMPLATE";
export const FETCHED_FAIL = "FETCHED_FAIL_LANYARD_TEMPLATE";
export const FETCHED_FILTER = "FETCHED_FILTER_LANYARD_TEMPLATE";
export const FETCH_NEXT = "FETCH_NEXT_LANYARD_TEMPLATE";
export const FILTER = "FILTER_LANYARD_TEMPLATE";
export const RESET_FILTER = "RESET_FILTER_LANYARD_TEMPLATE";
export const SET_SORTING = "SET_SORTING_LANYARD_TEMPLATE";
export const SET_FILTER = "SET_FILTER_LANYARD_TEMPLATE";
export const SET_PAGE = "SET_PAGE_LANYARD_TEMPLATE";
export const CHANGE_PAGE = "CHANGE_PAGE_LANYARD_TEMPLATE";
export const CHANGE_STATUS = "CHANGE_STATE_LANYARD_TEMPLATE";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_LANYARD_TEMPLATE";
export const CREATE_DATA = "CREATE_LANYARD_TEMPLATE";
export const UPDATE_DATA = "UPDATE_LANYARD_TEMPLATE";
export const DELETE_ITEM = "DELETE_LANYARD_TEMPLATE";

export function actionFetchLanyardTemplate(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetLanyardTemplate({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateLanyardTemplate(data) {
  const request = serviceCreateLanyardTemplate(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Saved",
          type: "success",
        });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateLanyardTemplate(data) {
  const request = serviceUpdateLanyardTemplate(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionDeleteLanyardTemplate(id) {
  const request = serviceDeleteLanyardTemplate({ id: id });
  return (dispatch) => {
    dispatch({ type: DELETE_ITEM, payload: id });
  };
}

export function actionChangePageLanyardTemplate(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterLanyardTemplate(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusLanyardTemplate(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterLanyardTemplate() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageLanyardTemplate(page) {
  const stateData = store.getState().lanyard_template;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchLanyardTemplate(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
